import React, { createContext, useContext, useState, useEffect } from 'react';

const FavoritesContext = createContext();

export function FavoritesProvider({ children }) {
    const [favorites, setFavorites] = useState(() => {
        const saved = localStorage.getItem('getiri-favorites');
        return saved ? JSON.parse(saved) : [];
    });

    useEffect(() => {
        localStorage.setItem('getiri-favorites', JSON.stringify(favorites));
    }, [favorites]);

    const addToFavorites = (calculation) => {
        const newFavorite = {
            id: Date.now(),
            name: calculation.name || `Favori ${favorites.length + 1}`,
            date: new Date().toISOString(),
            ...calculation
        };
        setFavorites(prev => [newFavorite, ...prev].slice(0, 10)); // Max 10 favorites
    };

    const removeFromFavorites = (id) => {
        setFavorites(prev => prev.filter(item => item.id !== id));
    };

    const updateFavoriteName = (id, name) => {
        setFavorites(prev => prev.map(item =>
            item.id === id ? { ...item, name } : item
        ));
    };

    const isFavorite = (params) => {
        return favorites.some(f =>
            f.balance === params.balance &&
            f.percentage === params.percentage &&
            f.targetDay === params.targetDay &&
            f.investmentRatio === params.investmentRatio
        );
    };

    return (
        <FavoritesContext.Provider value={{
            favorites,
            addToFavorites,
            removeFromFavorites,
            updateFavoriteName,
            isFavorite
        }}>
            {children}
        </FavoritesContext.Provider>
    );
}

export function useFavorites() {
    const context = useContext(FavoritesContext);
    if (!context) {
        throw new Error('useFavorites must be used within FavoritesProvider');
    }
    return context;
}
